module.exports = __webpack_public_path__ + "static/media/2.f5473657.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/2.jpg
// module id = 872
// module chunks = 0